module.exports = __webpack_public_path__ + "img/perik.c50e34b8.png";